import $ from 'jquery'

$('.custom-gform-button').on('click', () => {
    $('.section-contact .gform_footer input[type="submit"]').click()
})

$('.arrow-btn').on('click', () => {
    $('footer .gform_footer input[type="submit"]').click()
})
